import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';

import DialogContentText from '@material-ui/core/DialogContentText';
import { Link } from '@material-ui/core';

import { v4 as generateRandomID } from 'uuid';

import { App } from '../../base/AppContext';
import CloseBtn from '../../components/buttons/CloseBtn';

export default function PulseIndicator(props) {
  const [connected, setConnected] = React.useState(App.server.connected);
  const [showInfo, setShowInfo] = React.useState(false);

  React.useEffect(() => {
    const funcName = `${PulseIndicator.name}-${generateRandomID()}`;

    const setConnectedHandle = () => {
      setTimeout(() => {
        setConnected(true);
      }, 500);
    };
    App.eventsManager.on('event-connected', funcName, setConnectedHandle);

    const disconnectHandler = () => {
      setTimeout(() => {
        setConnected(false);
      });
    };
    App.eventsManager.on('event-disconnected', funcName, disconnectHandler);
    return () => {
      App.eventsManager.removeListener(
        'event-connected',
        funcName,
        setConnectedHandle
      );
      App.eventsManager.removeListener(
        'event-disconnected',
        funcName,
        disconnectHandler
      );
    };
  }, []);

  const handleClickOpen = () => {
    setShowInfo(true);
  };

  const handleClose = () => {
    setShowInfo(false);
  };

  const getPulse = (style) => {
    const updatedStyle = { ...style };
    updatedStyle.position = 'relative';
    updatedStyle.cursor = 'pointer';
    updatedStyle.display = 'inline-block';
    return (
      <IconButton
        style={{
          textAlign: 'center',
        }}
        onClick={() => {
          setShowInfo(true);
        }}>
        <div
          style={updatedStyle}
          className={`pulse ${connected ? 'connected' : 'disconnected'}`}
        />
      </IconButton>
    );
  };
  return (
    <>
      {getPulse({
        marginRight: '5px',
      })}
      <Dialog
        open={showInfo}
        fullWidth={true}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogContent
          style={{
            textAlign: 'center',
            height: '360px',
          }}>
          <CloseBtn onClick={handleClose} />
          <DialogContentText id="alert-dialog-description">
            <div
              style={{
                marginTop: '40px',
              }}>
              {connected && (
                <>
                  <div style={{ display: 'inline-block' }}>
                    Connected to real-time server{' '}
                  </div>
                </>
              )}
              {!connected && (
                <>
                  <div style={{ display: 'inline-block' }}>
                    Real-time server is disconnected:
                    <ol>
                      <li>check your internet connection</li>
                      <li>restart the application</li>
                      <li>contact support if the issue persists</li>
                    </ol>
                  </div>
                </>
              )}
              <div
                style={{
                  marginTop: '20px',
                  fontSize: '12px',
                  textAlign: 'center',
                }}>
                <div>
                  Version: {App.metadata.version} - Build {App.metadata.build}
                </div>
                <div>{App.metadata.date}</div>
              </div>
              <Link href={'https://www.meronex.com'} target={'_blank'}>
                <div
                  style={{
                    textAlign: 'center',
                    marginTop: '20px',
                  }}>
                  <div
                    style={{
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: 'gray',
                      textTransform: 'uppercase',
                    }}>
                    Powered By
                  </div>
                  <img
                    width={'155px'}
                    src={
                      'data:image/png;base64,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'
                    }
                  />
                </div>
              </Link>
              <div
                style={{
                  position: 'absolute',
                  bottom: '8px',
                  right: '5px',
                }}>
                {getPulse()}{' '}
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
}
